module["exports"] = [
  "Noord",
  "Oost",
  "West",
  "Zuid",
  "Nieuw",
  "Oud"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/nl/address/city_prefix.js
// module id = 1391
// module chunks = 0